import React, { useEffect, useRef, useState } from "react";

export default function GalleryCard({ img, type, onClick }) {
  const videoRef = useRef(null);
  const [poster, setPoster] = useState("");

  useEffect(() => {
    if (videoRef.current && !type?.includes("image")) {
      // Create poster image for iOS compatibility
      const generatePoster = async () => {
        try {
          const video = videoRef.current;
          video.currentTime = 1;

          // Wait for video to load and seek
          await new Promise((resolve) => {
            video.addEventListener("loadeddata", function onLoad() {
              video.removeEventListener("loadeddata", onLoad);
              resolve();
            });
          });

          // Create canvas and capture frame
          const canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          canvas.getContext("2d").drawImage(video, 0, 0);

          // Convert canvas to data URL for poster
          const posterUrl = canvas.toDataURL("image/jpeg");
          setPoster(posterUrl);
        } catch (error) {
          console.error("Error generating poster:", error);
        }
      };

      generatePoster();
    }
  }, [type, img]);

  return (
    <div
      className="flex justify-center w-full cursor-pointer transition-transform hover:scale-[1.02]"
      onClick={onClick}
    >
      {type && type.includes("image") ? (
        <img
          src={img}
          className="w-full h-auto object-cover md:h-[290px] rounded-sm"
          alt="Gallery image"
          loading="eager"
          decoding="sync"
          fetchPriority="high"
        />
      ) : (
        <video
          ref={videoRef}
          className="w-full h-auto object-cover md:h-[290px] rounded-sm md:object-contain"
          controls
          preload="metadata"
          playsInline
          poster={poster}
        >
          <source src={img} type={type} />
          <source src={img} type="video/quicktime" />
          <source src={img} type="video/mp4" />
          Your browser does not support video playback
        </video>
      )}
    </div>
  );
}
